import { Component, Input } from '@angular/core';
import { EventService, MapService, TelephonyService } from '../../../services';
import { IJobCardInfo } from '../../../interfaces/telephony/job-card-info';
import { TelephonyEventEnum } from '../../../interfaces/telephony/telephony-event';
import { MapControlTask } from '../../map-control/map-control.component';
import { ILogCallJobInfo, ILogCallTaskInfo } from '../../../interfaces/telephony/log-call-job-info';

@Component({
  selector: 'jobs-information-list',
  templateUrl: './jobs-information-list.component.html',
  styleUrls: ['./jobs-information-list.component.scss'],
})
export class JobsInformationListComponent {
  constructor(
    private mapService: MapService,
    private eventService: EventService,
    public telephonyService: TelephonyService,
  ) {}

  @Input('latestPosition') latestPosition: any;
  @Input('homePosition') homePosition: any;
  @Input('subWord') subWord: string = '';
  @Input('noResultsText') noResultsText: string = '';
  @Input('busy') busy: boolean;
  @Input() isCustomerView: boolean;

  private _jobs: IJobCardInfo[];

  @Input('jobs')
  public set jobs(value: IJobCardInfo[]) {
    this._jobs = value;

    if (value) {
      this.busy = false;
    }

    if (value && value.length > 1) {
      this.selectJob(value[0]);
    }
  }
  public get jobs(): IJobCardInfo[] {
    return this._jobs;
  }

  selectedJob: IJobCardInfo;

  selectedTaskId: number = null;
  mapControlTasks: MapControlTask[] = [];
  interactiveMap: boolean = false;
  staticMapSrc: string;

  selectJob(job: IJobCardInfo) {
    this.selectedJob = job;
    this.staticMapSrc = this.mapService.getStaticMapWithMarkers(job.tasks, {
      selectedTaskId: this.selectedTaskId,
      mapSize: '640x330',
    });
    this.mapControlTasks = job.tasks.map((task) => ({
      polyline: task.polyline,
      dropoffLocation: task.dropoffLocation,
      pickupLocation: task.pickupLocation,
      id: task.id,
    }));
    // this.interactiveMap = true;
  }

  logCall(job: IJobCardInfo) {
    let exTasks = job.tasks.map((tsk) => {
      return <ILogCallTaskInfo>{
        id: tsk.id,
        jobId: job.id,
        statusText: tsk.statusText,
        registrationNumber: tsk.vehicle.registrationNumber,
      };
    });

    let dto = <ILogCallJobInfo>{
      id: job.id,
      supplierId: job.supplierId,
      statusText: '',
      jobNumber: job.jobNumber,
      tasks: exTasks,
      isAssociatedThisCall: true,
    };

    //this.eventService.AssociateJobWithCall.emit(dto);
    this.eventService.InternalTelephonyEvent.emit({
      eventType: TelephonyEventEnum.LogCall,
      telephonyJobInfo: dto,
    });
  }
}
